/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Raw_ResponseInputs */

const en_read_along_ai_raw_response = /** @type {(inputs: Read_Along_Ai_Raw_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model response`)
};

const es_read_along_ai_raw_response = /** @type {(inputs: Read_Along_Ai_Raw_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta del modelo`)
};

/**
* | output |
* | --- |
* | "Model response" |
*
* @param {Read_Along_Ai_Raw_ResponseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_raw_response = /** @type {((inputs?: Read_Along_Ai_Raw_ResponseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Raw_ResponseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_raw_response(inputs)
	return en_read_along_ai_raw_response(inputs)
});